import type { FC, PropsWithChildren } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
export const AIContentMarkdown: FC<PropsWithChildren<{ children: string }>> = ({
  children
}) => {
  return (
    <div className="markdown-format-wrapper">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
};
